<template>
  <div class="printable-content simple-paper text-sm">
    <!-- header informations -->
    <div class="grid grid-cols-2 mb-8">
      <!-- uttrly informations -->
      <div>
        <div class="mb-4">
          <span class="block font-bold text-md mb-3">Uttrly</span>
          <span class="block mb-2">11810 Grand Park Ave, Suite 500</span>
          <span class="block mb-2">North Bethesda, MD 20852</span>
          <span class="block mb-2">202.681.0825</span>
          <span class="block">portal-admin@uttrly.com</span>
        </div>

        <div class="text-primary-700 font-semibold mb-4 text-2xl">
          <span>Work Order</span>
        </div>

        <!-- sub informations -->
        <div>
          <span v-if="sub?.name" class="block mb-1 font-bold">{{ sub.name }}</span>
          <span v-if="sub?.address" class="block mb-1">{{ sub.address }}</span>
        </div>
      </div>

      <!-- log and work order header informations -->
      <div>
        <div class="flex justify-end mb-7">
          <img
            :src="logo"
            alt="Uttrly"
          />
        </div>
        <div class="text-right">
          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">WO#</span>
            <span>{{ workOrder.workOrderId }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">DATE</span>
            <span>{{ getLocalDate(workOrder.date) }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">TERMS</span>
            <span>Net 30</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Project site -->
    <div class="mb-4">
      <span class="font-bold text-md mb-3">Project Site: </span>
      <span>{{ project?.address }}</span>
    </div>

    <!-- Work order items -->
    <div class="pt-3 mt-3">
      <div>
        <h3 class="text-xl font-medium leading-10 tracking-tight">Details</h3>
      </div>

      <!-- work order items -->
      <div class="mt-2">
        <div
          v-for="(woItem, idx) in workOrder.items"
          :key="woItem.id"
          :class="[
            idx != workOrder.items.length - 1 ? 'border-b border-gray-200 py-4' : 'py-4'
          ]"
        >
          <div>
            <div class="grid grid-cols-5 gap-4">
              <div class="col-span-4 flex items-start">
                <div>
                  <div class="flex items-center">
                    <span class="font-bold">{{ woItem.name }}</span>
                  </div>

                  <div class="text-justify" v-html="woItem.scopeOfWork" />
                </div>
              </div>

              <!-- line item total -->
              <div class="text-right text-sm">
                <span class="font-semibold">{{ currency(woItem.cost) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- total -->
      <hr class="border-b-slate-200 border-2 mt-3" />

      <div class="my-4">
        <div class="grid grid-cols-5 gap-4">
          <div class="col-span-4">
            <span class="text-slate-500 text-xs">Thank you for your business and have a great day</span>
          </div>

          <div>
            <div class="flex items-center justify-end gap-2">
              <span class="font-bold">Total:</span>
              <span>{{ currency(workOrder.total) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts' setup>
import { Project } from '@/models/project'
import logo from '@/assets/images/logo.png'
import { computed, PropType } from 'vue'
import { currency } from '@/utils'
import { Subcontractor } from '@/models/subcontractor'
import { WorkOrder } from '@/models/workOrder'

defineProps({
  project: {
    type: Object as PropType<Project>,
    required: true
  },
  sub: {
    type: Object as PropType<Subcontractor>,
    required: true
  },
  workOrder: {
    type: Object as PropType<WorkOrder>,
    required: true
  },
})

const getLocalDate = computed(() => (date: Date) => {
  return new Date(date).toLocaleDateString()
})
</script>

<style lang="scss" scoped>
.printable-content {
  width: 200mm !important; /* Largeur A4 */
  padding: 5mm !important; /* Marges */
  /* min-height: 257mm !important; Hauteur A4 */
  background: white;
}

.simple-paper {
  border: 0.7px solid #ccc;
  padding: 20px;
}
</style>
